import React from 'react'
import PropTypes from 'prop-types'
import TinyPopover from 'components/Utils/TinyPopover'

export default class PopoverOnClick extends React.Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    content: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
    position: PropTypes.string.isRequired,
    align: PropTypes.string.isRequired,
    transitionDuration: PropTypes.number,
    disabled: PropTypes.bool,
    containerStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    closeOnClickOutside: PropTypes.bool.isRequired,
    onIsOpenChange: PropTypes.func,
    className: PropTypes.string,
  }

  static defaultProps = {
    align: 'start',
    transitionDuration: 0.25,
    closeOnClickOutside: true,
    onIsOpenChange: () => {},
  }

  state = {
    isOpen: false,
  }

  render() {
    const {
      containerStyle,
      disabled,
      children,
      position,
      align,
      closeOnClickOutside,
      className,
      transitionDuration,
    } = this.props

    if (disabled) {
      return children
    }

    const styles =
      typeof containerStyle === 'function'
        ? (...args) => ({ overflow: 'visible', ...containerStyle(...args) })
        : containerStyle

    return (
      <TinyPopover
        isOpen={this.state.isOpen}
        transitionDuration={transitionDuration}
        position={position}
        align={align}
        content={this.renderContent()}
        onClickOutside={closeOnClickOutside ? this.close : null}
        // overrides default `overflow: hidden`, allowing box-shadows to be visible
        containerStyle={styles}
        className={`color-mode-elevated ${className}`}
      >
        {React.cloneElement(React.Children.only(children), {
          onClick: this.toggle,
        })}
      </TinyPopover>
    )
  }

  renderContent() {
    if (typeof this.props.content === 'function') {
      return ({ ...propsFromPopopover }) =>
        this.props.content({
          closePopover: this.close,
          isOpen: this.state.isOpen,
          ...propsFromPopopover,
        })
    }
    return this.props.content
  }

  toggle = event => {
    event.preventDefault()
    // We need to let the click propagate so other popovers overlays can be capture the event
    // event.stopPropagation()
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }), this.isOpenCallback)
  }

  close = () => {
    this.setState({ isOpen: false }, this.isOpenCallback)
  }

  isOpenCallback = () => {
    this.props.onIsOpenChange({ isOpen: this.state.isOpen })
  }
}
